export const loadProject = (projectId) => {
  return fetch(`http://localhost:4000/project/${projectId}`, {
    cache: "no-store",
  })
    .then((res) => res.json())
    .catch((err) => {
      console.error("LOAD ERROR:", err);
      return null;
    });
};

export const saveProject = (projectId, data) => {
  return fetch(`http://localhost:4000/project/${projectId}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  }).catch((err) => {
    console.error("SAVE ERROR:", err);
  });
};